import React, { useCallback, useContext, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { GlobalContext, globalOnDemandVars } from '../../../../helper/context'
import {
  handleErrorInCatch,
  reorderForBnD,
  showToastByMenuDirection,
  truncateDefault
} from '../../../../helper/functions'
import DialogComp from '../../../commonInterface/dialog'
import { uniqueId, throttle } from 'lodash'
import InfiniteScroll from 'react-infinite-scroll-component'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { hasScrollbarAlways, hasScrollbarIfHover } from '../../../../helper/CSSclasses'
import { Button, ButtonGroup, Tooltip } from '@blueprintjs/core'
import { OneItemForInsertForm } from './oneItemForInsertForm'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'
import Loadable from 'react-loadable'
import LoadingCover from '../../../commonInterface/loadingCover'
import { createMediaItemAndReturnGlobalId } from '../../../../backend/mediaItems/createData'
import { updateMediaItemF } from '../../../../backend/mediaItems/updateData'
import { extractCountForId } from '../../../../backend/mediaItems/initData'
import produce from 'immer'
import { OverlayProps } from '../../../../helper/configs'
import { Type2Or3Item } from '../../../list/uploadType2/class'
import { createUploadType2 } from '../../../../backend/uploadType2/createData'
import { Type1Item } from './type1Class'

const Loading = ({ pastDelay, error, timedOut }) => {
  if (error) {
    return <div>error</div>
  } else if (timedOut) {
    return <div>timeOut</div>
  } else if (pastDelay) {
    return <div css={css`width: 100%; height: 100%; margin: 4px;`} className={'bp3-skeleton'} />
  } else {
    return null
  }
}
const WrapperForLoader = LoadableVisibility({
  // 여기 helper 루트 수정해야함
  loader: () => import('../../../../helper/WrapperForLoader'),
  loading: Loading
})

function InsertFormBaseAddOn ({ forDialog, items, setItems, ClassForType, EditorMini, EditorForDialog, getCurrentContentData, getCurrentMultiContentData, clearCurrentContent }) {
  // const contextValue = useContext(GlobalContext)
  //
  // const waitingItems = contextValue.waitingItemsForType1
  // const setWaitingItems = globalOnDemandVars.set_waitingItemsForType1
  // const usedItems = contextValue.usedItemsForType1
  // const setUsedItems = globalOnDemandVars.set_usedItemsForType1
  const [limitForItems, setLimitItems] = useState(forDialog ? 20 : 10)
  const onDragEnd = useCallback(
    result => {
      const { source, destination } = result

      // dropped outside the list
      if (!destination) {
        return
      }

      const nextItems = reorderForBnD(
        items,
        source.index,
        destination.index
      )
      setItems(nextItems)

      const currentItems = nextItems.slice(0, limitForItems)
      currentItems.forEach((item, i) => {
        updateMediaItemF(item.globalId, {
          typeOrder: i
        })
      })
    }
    ,
    [items, limitForItems, setItems]
  )
  // -----------------------------------------------------------------------------------------------------------

  const [dialogOpen, setDialogOpen] = useState(false)
  const [inDialog, setInDialog] = useState({
    title: null,
    content: null
  })
  const dialog = useMemo(() => (<DialogComp isOpen={dialogOpen} setDialogOpen={setDialogOpen} title={inDialog.title} type={'bigger'}>
    {inDialog.content}
  </DialogComp>), [dialogOpen, inDialog.content, inDialog.title])
  const setDialog = useCallback(
    (title, content) => {
      setDialogOpen(true)
      setInDialog({
        title,
        content
      })
    },
    []
  )

  // -----------------------------------------------------------------------------------------------------------

  const divId = useMemo(() => (uniqueId()), [])

  const inDroppable = useMemo(() => (<InfiniteScroll style={{ overflow: 'visible' }}
    next={() => {
      setLimitItems(limitForItems + 10)
    }}
    dataLength={limitForItems}
    loader={'......'}
    hasMore={items.length > limitForItems}
    scrollThreshold='50px'
    scrollableTarget={divId}
  >{items.slice(0, limitForItems).map((item, index) => {
      if (!item) {
        return null
      }
      return (
        <Draggable
          key={item.type + item.id} draggableId={item.type + item.id}
          index={index}>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <OneItemForInsertForm
                dragHandleProps={provided.dragHandleProps}
                ClassForType={ClassForType}
                item={item} setDialog={setDialog}
                items={items} setItems={setItems}
              />
            </div>
          )}
        </Draggable>
      )
    })
    }</InfiniteScroll>), [ClassForType, divId, items, limitForItems, setDialog, setItems])

  const context = useContext(GlobalContext)

  const onUpToType1 = useCallback(
    throttle(async () => {
      if (!getCurrentMultiContentData) {
        const currentContentData = getCurrentContentData()
        const globalId = await createMediaItemAndReturnGlobalId(currentContentData.id, currentContentData.type, currentContentData.title, currentContentData.content)
        currentContentData.setGlobalId(globalId)
        const itemForType1 = new Type1Item(currentContentData.type, currentContentData.title, currentContentData.content, currentContentData.id, currentContentData.count || extractCountForId(currentContentData.id), globalId)
        await updateMediaItemF(globalId, {
          inTypeItems: false,
          inType1Items: true,
          inWaitingItemsForType1: true,
          type1Order: 0
        })
        globalOnDemandVars.set_type1Items(produce(globalOnDemandVars.type1Items(), (draft) => {
          draft.push(itemForType1)
        }))
        globalOnDemandVars.set_waitingItemsForType1(produce(globalOnDemandVars.waitingItemsForType1(), (draft) => {
          draft.push(itemForType1)
        }))
        showToastByMenuDirection({
          message: `'${truncateDefault(currentContentData.title)}' uploaded to Type 1`,
          intent: 'success',
          icon: 'media'
        })
      } else {
        const currentMultiContentData = getCurrentMultiContentData()
        const globalIdArray = await Promise.all(currentMultiContentData.map((content) => (
          createMediaItemAndReturnGlobalId(content.id, content.type, content.title, content.content)
        )))
        currentMultiContentData.forEach((content, index) => {
          content.setGlobalId(globalIdArray[index])
        })
        const itemForType1Array = currentMultiContentData.map((currentContentData) => (
          new Type1Item(currentContentData.type, currentContentData.title, currentContentData.content, currentContentData.id, currentContentData.count || extractCountForId(currentContentData.id), currentContentData.globalId)
        ))
        await Promise.all(globalIdArray.map((globalId) => (updateMediaItemF(globalId, {
          inTypeItems: false,
          inType1Items: true,
          inWaitingItemsForType1: true,
          type1Order: 0
        }))))
        globalOnDemandVars.set_type1Items(itemForType1Array.concat(globalOnDemandVars.type1Items()))
        globalOnDemandVars.set_waitingItemsForType1(itemForType1Array.concat(globalOnDemandVars.waitingItemsForType1()))
        showToastByMenuDirection({
          message: `Multiple media uploaded to Type 1`,
          intent: 'success',
          icon: 'media'
        })
      }

      clearCurrentContent()
    }, 1000, { trailing: true, leading: true }),
    [getCurrentMultiContentData, getCurrentContentData]
  )

  const onUpToType2 = useCallback(
    throttle(async () => {
      if (!getCurrentMultiContentData) {
        const currentContentData = getCurrentContentData()
        const itemForUploadType2 = new Type2Or3Item({
          type: currentContentData.type,
          title: currentContentData.title,
          content: currentContentData.content
        })
        await createUploadType2(itemForUploadType2.id, {
          type: itemForUploadType2.type,
          title: itemForUploadType2.title,
          content: itemForUploadType2.content,
          timeStamp: itemForUploadType2.timeStamp
        })
        globalOnDemandVars.uploadType2s()[itemForUploadType2.id] = itemForUploadType2
        globalOnDemandVars.set_uploadType2sInWaitingList(produce(globalOnDemandVars.uploadType2sInWaitingList(), draft => {
          draft.unshift(itemForUploadType2)
        }))
        showToastByMenuDirection({
          message: `'${truncateDefault(itemForUploadType2.title)}' uploaded to Type 2`,
          intent: 'success',
          icon: 'heat-grid'
        })
      } else {
        const currentMultiContentData = getCurrentMultiContentData()
        const itemForType2Array = currentMultiContentData.map((currentContentData) => (
          new Type2Or3Item({
            type: currentContentData.type,
            title: currentContentData.title,
            content: currentContentData.content
          })
        ))
        await Promise.all(itemForType2Array.map((itemForUploadType2) => (
          createUploadType2(itemForUploadType2.id, {
            type: itemForUploadType2.type,
            title: itemForUploadType2.title,
            content: itemForUploadType2.content,
            timeStamp: itemForUploadType2.timeStamp
          })
        )))
        itemForType2Array.forEach((itemForUploadType2) => {
          globalOnDemandVars.uploadType2s()[itemForUploadType2.id] = itemForUploadType2
        })
        globalOnDemandVars.set_uploadType2sInWaitingList(itemForType2Array.concat(globalOnDemandVars.uploadType2sInWaitingList()))
        showToastByMenuDirection({
          message: `Multiple media uploaded to Type 2`,
          intent: 'success',
          icon: 'heat-grid'
        })
      }

      clearCurrentContent()
    }, 1000, { trailing: true, leading: true }),
    [getCurrentMultiContentData, getCurrentContentData]
  )

  const onKeep = useCallback(
    throttle(async () => {
      if (!getCurrentMultiContentData) {
        const currentContentData = getCurrentContentData()
        // hackable 하게 만들기위해 걍 빈 데이터여도 저장되게 하
        // if (currentContentData) {
        const globalId = await createMediaItemAndReturnGlobalId(currentContentData.id, currentContentData.type, currentContentData.title, currentContentData.content)
        if (process.env.NODE_ENV !== 'production') {
          console.tron.log('media createMediaItemAndReturnGlobalId then')
        }
        currentContentData.setGlobalId(globalId)
        setItems([].concat(currentContentData, items))
      } else {
        const currentMultiContentData = getCurrentMultiContentData()
        const globalIdArray = await Promise.all(currentMultiContentData.map((content) => (
          createMediaItemAndReturnGlobalId(content.id, content.type, content.title, content.content)
        )))
        currentMultiContentData.forEach((content, index) => {
          content.setGlobalId(globalIdArray[index])
        })
        setItems([].concat(currentMultiContentData, items))
      }
      clearCurrentContent()
      // }
    }
    , 1000, { trailing: true, leading: true }),
    [clearCurrentContent, getCurrentContentData, items, setItems]
  )
  return (
    useMemo(() => (<div css={css`position: relative;`}>
      {context.typeListsReady ? null : <LoadingCover text={'Loading Data'} />}
      {dialog}
      <div css={css`padding: 5px 2px 2px 10px; position: relative;`}>
        <div css={css`max-width: 100%; margin-bottom: 5px;`}>
          <div className={'bp3-card bp3-elevation-3' + ' ' + hasScrollbarAlways} css={css`
          z-index: 0; position: relative; padding: 0; margin-bottom: 2px; ${forDialog ? 'width: 70vw; height: 65vh;' : 'width: 100%; min-height: 300px; max-height: 600px;'} overflow: auto; background-color: var(--gray3);
          `}>{
              forDialog ? EditorForDialog : EditorMini
            }</div>
          <ButtonGroup fill css={css`flex-wrap: wrap;`} minimal>
            <Tooltip {...OverlayProps} position='top' content={'Upload to Type 1 (Normal Upload)'} intent={'success'}>
              <Button text={'Type 1'} icon='media' intent={'success'} onClick={onUpToType1} />
            </Tooltip>
            <Tooltip {...OverlayProps} position='top' content={'Upload to Type 2 (Divide and Conquer This Media)'} intent={'success'}>
              <Button text={'Type 2'} icon='heat-grid' intent={'success'} onClick={onUpToType2} />
            </Tooltip>
            <Button text={'Keep'} intent={'success'} onClick={onKeep} />
            <Button text={'Clear'} onClick={clearCurrentContent} />
          </ButtonGroup>
        </div>
        <WrapperForLoader content={
          <DragDropContext onDragEnd={onDragEnd}>
            <div css={css`width: 100%;`}>
              <Droppable droppableId='items'>
                {(provided, snapshot) => (
                  <div id={divId}
                    ref={provided.innerRef} {...provided.droppableProps}
                    style={{
                      backgroundColor: snapshot.isDraggingOver ? 'var(--primary5)' : 'transparent'
                    }}
                    css={css`width: 100%; max-height: ${forDialog ? 300 : 100}px; overflow-y: scroll;`}
                    className={hasScrollbarIfHover + ' ' + 'bp3-card'}
                  >
                    {inDroppable}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable></div>
          </DragDropContext>
        } />
      </div></div>), [context.typeListsReady, dialog, forDialog, EditorForDialog, EditorMini, onUpToType1, onUpToType2, onKeep, clearCurrentContent, onDragEnd, divId, inDroppable])
  )
}

export default InsertFormBaseAddOn
